import React, { useEffect } from "react";
import { Chip, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import { blue, red } from "@mui/material/colors";
import AddIcon from "@mui/icons-material/Add";
import RegularButton from "../../components/CustomButtons/Button";
import { verifyEmail } from "../../helpers/validation";
import { useSearch } from "../../hooks/useSearch";

export const EmailForm = ({
  email, emails, onChange, setValues, reset, errors
}) => {
  const { setSnackbar } = useSearch();

  const handleAdd = () => {
    const newEmails = email
      .split(/[,;\s]/)
      .map((e) => e.trim())
      .filter(Boolean);

    const validEmails = newEmails.filter(verifyEmail);
    const invalidEmails = newEmails.filter(e => !verifyEmail(e));

    if (invalidEmails.length > 0) {
      setSnackbar(`Email(s) inválido(s): ${invalidEmails.join(", ")}`, "danger");
    }

    if (validEmails.length > 0) {
      const uniqueNewEmails = validEmails.filter((em) => !emails.includes(em));
      setValues({
        emails: [...emails, ...uniqueNewEmails],
        email: "",
      });
    }
  };

  const handleRemove = (em) => {
    setValues({
      emails: emails.filter(e => e !== em),
    });
  };

  useEffect(() => reset(), []);

  return (
    <>
      <Grid item xs={12}>
        <TextField
          label="Email"
          placeholder="ejemplo@ejemplo.com, ejemplo2@ejemplo.com"
          type="email"
          variant="outlined"
          name="email"
          value={email}
          onChange={onChange}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RegularButton justIcon round color="transparent" onClick={handleAdd}>
                  <AddIcon style={{ color: blue[500] }} />
                </RegularButton>
              </InputAdornment>
            ),
          }}
          error={errors.emails}
          helperText={errors.emails}
        />
      </Grid>
      <Grid item xs={12} style={{ textAlign: "center" }}>
        <Typography variant="caption" style={{ color: red[500] }}>
          Ingresa los emails separados por comas o punto y coma. Dar click en el botón + para agregar un email
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {emails.map(em => (
          <Chip key={em} label={em} onDelete={() => handleRemove(em)} style={{ marginRight: 4 }} />
        ))}
      </Grid>
    </>
  );
};
